/**
 * KAUF-LINK — HIER ERSETZEN
 *
 * Der Checkout-Link, auf den die Kauf-Buttons (Angebots-Block und Schluss-CTA) zeigen.
 */
export const checkoutUrl = 'https://das-ultimative-urban-farming-system-2026.impultienda.ar/checkout'
